// extracted by mini-css-extract-plugin
export default {"chatProviderIntroMessage":"styles_chatProviderIntroMessage__ri5xv"};